import React, { PureComponent } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Card, Progress, Segment, Label, Table } from 'semantic-ui-react';
import moment from 'moment';

function getColorFromtype(type, category) {
  if (type === 'EXAM_DETAILS') return 'blue';
  else if (type === 'TEACHER_REMARK') {
    if (category === 'MONTHLY_PROGRESS') {
      return 'olive';
    }
    return 'green';
  } else if (type === 'STUDENT_FEEDBACK') {
    return 'orange';
  }
}

let divStyle = {
  paddingTop: 60,
  paddingBottom: 60,
  margin: 20,
  backgroundColor: '#85AFC7',
  width: 100,
  minHeight: 500,
};

export default class RemarkTimeline extends PureComponent {
  constructor() {
    super();
    this.state = {
      combinedList: [],
    };
  }

  componentDidMount() {
    const { examDetails, teacherRemarks, studentFeedback } = this.props;
    let newCombinedList = [];
    if (examDetails) {
      Object.entries(examDetails).forEach(([exm_id, exm]) => {
        console.log('exm', exm);
        let exm_topics = exm.exam_topics;
        if (!exm_topics) {
          return;
        }
        let clean_exm_topics = exm_topics.replace('{', '');
        clean_exm_topics = clean_exm_topics.replace('}', '');
        clean_exm_topics = clean_exm_topics.replace(/"/g, '');
        let topics = clean_exm_topics.split(',');
        newCombinedList.push({
          date: exm.exam_date,
          score: exm.student_score,
          topics: topics,
          totalScore: exm.total_score,
          exam_type: exm.exam_type,
          type: 'EXAM_DETAILS',
          meta: exm.meta,
        });
      });
    }
    if (teacherRemarks) {
      Object.entries(teacherRemarks).forEach(([remarkId, rem]) => {
        console.log('rem', rem);
        newCombinedList.push({
          date: rem.created_on,
          category: rem.category,
          meta: rem.meta,
          teacher: rem.teacherId,
          remark: rem.remark,
          type: 'TEACHER_REMARK',
        });
      });
    }

    if (studentFeedback) {
      Object.entries(studentFeedback).forEach(([ratingId, stdFd]) => {
        newCombinedList.push({
          date: stdFd.created_on,
          feedback: stdFd.feedback,
          rating: stdFd.rating,
          type: 'STUDENT_FEEDBACK',
        });
      });
    }

    newCombinedList.sort(function(a, b) {
      console.log('date');
      let dateA = new Date(a.date);
      let dateB = new Date(b.date);
      if (dateA > dateB) {
        return -1;
      } else {
        return 1;
      }
    });

    this.setState({ combinedList: newCombinedList });
  }

  getJSXObjects = () => {
    const { combinedList } = this.state;
    let returnObj = Object.values(combinedList).map((dataPart, i) => {
      if (dataPart.type === 'EXAM_DETAILS') {
        return (
          <div style={divStyle}>
            <Segment basic>
              <Card style={{ minHeight: 300 }} color={getColorFromtype(dataPart.type)}>
                <Card.Content>
                  <Card.Header>
                    <Card.Content textAlign="center">
                      {' '}
                      {moment(dataPart.date).format('ll')}{' '}
                    </Card.Content>
                    <Progress percent={100} color={getColorFromtype(dataPart.type)} />
                    <Card.Content textAlign="center"> {dataPart.exam_type} </Card.Content>
                  </Card.Header>
                </Card.Content>
                <Card.Content>
                  <Table celled striped>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>Score</Table.Cell>
                        <Table.Cell collapsing textAlign="left">
                          {dataPart.score || 'NA'}/{dataPart.totalScore || 'NA'}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Topics</Table.Cell>
                        <Table.Cell collapsing textAlign="left">
                          <Label.Group color="blue">
                            {dataPart.topics.map(tp => (
                              <div>
                                <Label textAlign="left"> {tp}</Label>
                              </div>
                            ))}
                          </Label.Group>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Content>
                <Card.Meta>Exam Details</Card.Meta>
              </Card>
            </Segment>
          </div>
        );
      } else if (dataPart.type === 'TEACHER_REMARK') {
        return (
          <div style={divStyle}>
            <Segment basic>
              <Card style={{ minHeight: 300 }} color={getColorFromtype(dataPart.type)}>
                <Card.Content>
                  <Card.Header>
                    <Card.Content textAlign="center">
                      {' '}
                      {moment(dataPart.date).format('ll')}{' '}
                    </Card.Content>
                    <Progress
                      percent={100}
                      color={getColorFromtype(dataPart.type, dataPart.category)}
                    />
                    <Card.Content textAlign="center"> {dataPart.category} </Card.Content>
                  </Card.Header>
                </Card.Content>
                <Card.Content textAlign="Left"> {dataPart.remark} </Card.Content>
                <Card.Meta>Teacher Remark</Card.Meta>
              </Card>
            </Segment>
          </div>
        );
      } else if (dataPart.type === 'STUDENT_FEEDBACK') {
        return (
          <div style={divStyle}>
            <Segment basic>
              <Card style={{ minHeight: 300 }} color={getColorFromtype(dataPart.type)}>
                <Card.Content>
                  <Card.Header>
                    <Card.Content textAlign="center">
                      {' '}
                      {moment(dataPart.date).format('ll')}{' '}
                    </Card.Content>
                    <Progress
                      percent={100}
                      color={getColorFromtype(dataPart.type, dataPart.category)}
                    />
                    <Card.Content textAlign="center">
                      {' '}
                      Student Rating: {dataPart.rating}{' '}
                    </Card.Content>
                  </Card.Header>
                </Card.Content>
                <Card.Content textAlign="Left"> {dataPart.feedback} </Card.Content>
                <Card.Meta>Student Feedback</Card.Meta>
              </Card>
            </Segment>
          </div>
        );
      }
    });
    if (returnObj.length === 0) {
      return <div>No Data Available</div>;
    }
    //Sort returnObj by descending date;
    return returnObj;
  };

  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
    };
    return (
      <div style={{ minHeight: 500 }}>
        <Slider {...settings} style={{ minHeight: 400 }}>
          {this.getJSXObjects()}
        </Slider>
      </div>
    );
  }
}
